module.exports = __webpack_public_path__ + "img/hot_ysyl.480e2b6b.svg";